export var CATERING_MENU_AVAILABILITY_VALUES = ["not_catering", "catering", "both"];
export var isCateringOrderMode = function (value) {
    if (value === true || value === 1) {
        return true;
    }
    if (typeof value !== "string") {
        return false;
    }
    var normalizedValue = value.trim().toLowerCase();
    return normalizedValue === "1" || normalizedValue === "true" || normalizedValue === "yes";
};
export var normalizeCateringMenuAvailability = function (value) {
    if (value === "catering" || value === "both") {
        return value;
    }
    return "not_catering";
};
export var isAvailableForOrderMode = function (value, isCateringOrder) {
    var availability = normalizeCateringMenuAvailability(value);
    if (isCateringOrder) {
        return availability === "catering" || availability === "both";
    }
    return availability === "not_catering" || availability === "both";
};
